module.exports = __webpack_public_path__ + "img/gradient-filler-progress-light.5ea755a.svg";